var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon14(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10213",
    "data-name": "Group 10213",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.55,
    height: 33.643,
    viewBox: "0 0 23.55 33.643",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2236",
    "data-name": "Rectangle 2236",
    width: 23.55,
    height: 33.643,
    fill: "#ffe800"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10212",
    "data-name": "Group 10212",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27576",
    "data-name": "Path 27576",
    d: "M12.966,24.041l-.244-.2a1.42,1.42,0,0,0-.307-.157l-.307-.132a1.657,1.657,0,0,0-1.523.455,2.013,2.013,0,0,0-.359.552,1.686,1.686,0,0,0,2.189,2.209,2.38,2.38,0,0,0,.552-.377,1.669,1.669,0,0,0,.359-1.832,1.72,1.72,0,0,0-.359-.516M18.5,0H5.046A5.048,5.048,0,0,0,0,5.046V28.6a5.048,5.048,0,0,0,5.046,5.046H18.5A5.048,5.048,0,0,0,23.55,28.6V5.046A5.048,5.048,0,0,0,18.5,0m1.682,28.6A1.683,1.683,0,0,1,18.5,30.279H5.046A1.683,1.683,0,0,1,3.364,28.6V5.046A1.683,1.683,0,0,1,5.046,3.364H18.5a1.683,1.683,0,0,1,1.682,1.682Z",
    fill: "#ffe800"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon14);
export default __webpack_public_path__ + "static/media/social_icon14.e57eb012de21fd687c36dfc67e3b795e.svg";
export { ForwardRef as ReactComponent };